import { IVendorState } from '@/store/vendor';
import { IVendorGetters } from './getters.types';
import { IVendor, Vendor } from '@/models';

export const getters: IVendorGetters = {
  getVendors(state: IVendorState): IVendor[] {
    return state.vendors.map(data => new Vendor(data));
  },

  getVendorById: (state: IVendorState) => (id: string): IVendor | undefined => {
    const data = state.vendors.find(vendor => vendor.id === id);
    if (!data) {
      return undefined;
    }

    return new Vendor(data);
  }
};
